import { AuthLayoutWithNav } from '@/components/shared/layouts'
import {
  authenticateBeforeLoad,
  loadAuthenticatedUser,
} from '@/shared/utils/route-utils/auth-route-config'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ location }) => authenticateBeforeLoad(location),
  loader: async ({ context: { queryClient, userId } }) =>
    loadAuthenticatedUser(queryClient, userId),
  component: AuthComponent,
})

function AuthComponent() {
  return (
    <AuthLayoutWithNav>
      <Outlet />
    </AuthLayoutWithNav>
  )
}
